/**
 * Nicaraguan córdoba.
 */
export var NIO = {
  code: 'NIO',
  base: 10,
  exponent: 2
};